
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div class=\"modal dialog-success text-center\">\n  <h2>{{#t}}Your message was sent to Support{{/t}}</h2>\n  <div class=\"message\">\n    <p>{{{message}}}</p>\n  </div>\n  <button class=\"settings-button primary-button cta-primary cta-base-p\">{{#t}}Back to Subscriptions{{/t}}</button>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  